<script lang="ts">
export default {
  name: 'KkAcceptImageDescription'
}
</script>

<script lang="ts" setup>
import { ref } from 'vue'
import { KkTooltip } from '../../../components/base'

export type Props = {
  label?: string
  format?: string
  min?: string
  max?: string
  minSize?: string
  maxSize?: string
  minResolution?: string
}

const props = withDefaults(defineProps<Props>(), {
  format: 'JPEG,PNG',
  min: '720',
  max: '3,000px',
  minSize: '10KB',
  maxSize: '5MB',
  minResolution: '250px',
})
const isVisible = ref(false)
</script>

<template>
  <KkTooltip
    :is-visible="isVisible"
    :label="props.label || $t('models.mediaLibraryUpload.label')"
    width="400px"
    top="24px"
    @show-tooltip="isVisible = true"
    @hide-tooltip="isVisible = false"
  >
    <dl :class="$style.content">
      <dt :class="$style.title">{{ $t('models.mediaLibraryUpload.format') }}</dt>
      <dd>{{ props.format }}</dd>
      <dt :class="$style.title">{{ $t('models.mediaLibraryUpload.fileInfo') }}</dt>
      <dd>
        {{ $t('models.mediaLibraryUpload.imageSize', { min: props.min, max: props.max, minSize: props.minSize, maxSize: props.maxSize }) }}
      </dd>
    </dl>
  </KkTooltip>
</template>

<style lang="scss" module>
.content {
  font-size: 12px;
}
.title {
  font-weight: bold;
  &:not(:first-child) {
    margin-top: 12px;
  }
}
</style>
